import moment from 'moment';

export function minutesToTime(minutes: number, format?: string): string {
  const time = `${Math.floor(minutes / 60)}:${minutes % 60 === 0 ? '00' : minutes % 60}`;
  if (format) {
    return moment(time, 'HH:mm').format(format);
  } else {
    return time;
  }
}

export const approximateTime = (seconds: number) => {
  if (seconds < 60) {
    return `${Math.floor(seconds)} s`;
  } else if (seconds < 3600) {
    return `${Math.floor(seconds / 60)} min ${Math.floor(seconds % 60)} s`;
  } else if (seconds < 86400) {
    return `${Math.floor(seconds / 3600)} h ${Math.floor((seconds % 3600) / 60)} min`;
  } else {
    return `${Math.floor(seconds / 86400)} d ${Math.floor((seconds % 86400) / 3600)} h`;
  }
};
